import initialState from './initialState';
import {
  FETCH_CHART_ACCOUNTS,
  FETCH_CHART_ACCOUNTS_SUCCESS,
  FETCH_CHART_ACCOUNTS_FAILURE,
  FETCH_INITIAL_DATA_FOR_CHART_MODAL_SUCCESS,
  SAVING_CHART,
  SAVING_CHART_SUCCESS,
  SAVING_CHART_FAILURE,
  FETCH_INITIAL_DATA_FOR_CHART_ACCOUNT_MODAL_SUCCESS,
  SAVING_CHART_ACCOUNT,
  SAVING_CHART_ACCOUNT_SUCCESS,
  SAVING_CHART_ACCOUNT_FAILURE,
  FETCH_CHARTS_SUCCESS,
  SELECT_CHART,
  IMPORT_CHART_OF_ACCOUNTS,
  IMPORT_CHART_OF_ACCOUNTS_SUCCESS,
  IMPORT_CHART_OF_ACCOUNTS_FAILURE,
  REMOVING_CHART,
  REMOVING_CHART_SUCCESS,
  REMOVING_CHART_FAILURE,
  REMOVING_CHART_ACCOUNT,
  REMOVING_CHART_ACCOUNT_SUCCESS,
  REMOVING_CHART_ACCOUNT_FAILURE,
  FETCH_INITIAL_DATA_FOR_CHART_ACCOUNT_MODAL,
  FETCH_INITIAL_DATA_FOR_CHART_ACCOUNT_MODAL_FAILURE,
} from './types';

function chartOfAccounts(state = initialState, action) {
  switch (action.type) {
    case FETCH_CHART_ACCOUNTS:
      return {
        ...state,
        fetchChartAccountsError: initialState.fetchChartAccountsError,
        chartAccountsLoading: true,
      };
    case FETCH_CHART_ACCOUNTS_SUCCESS:
      return {
        ...state,
        chartAccounts: action.chartAccounts.accounts,
        chart: action.chartAccounts.chart,
        canModifyByAssignment: action.chartAccounts.chartPrivilege.hasEditPrivilege === 1,
        chartAccountsLoading: false,
      };
    case FETCH_CHART_ACCOUNTS_FAILURE:
      return {
        ...state,
        chartAccounts: initialState.chartAccounts,
        chart: initialState.chart,
        canModifyByAssignment: initialState.canModifyByAssignment,
        fetchChartAccountsError: action.errorMessage || initialState.fetchChartAccountsError,
        chartAccountsLoading: false,
      };
    case FETCH_CHARTS_SUCCESS:
      return {
        ...state,
        chartNames: action.chartNames,
      };
    case SELECT_CHART:
      return {
        ...state,
        chartName: action.chartName,
      };
    case FETCH_INITIAL_DATA_FOR_CHART_MODAL_SUCCESS:
      return {
        ...state,
        chartToEdit: action.chartToEdit,
      };
    case SAVING_CHART:
      return {
        ...state,
        isSavingChartInProgress: true,
      };
    case SAVING_CHART_SUCCESS:
    case SAVING_CHART_FAILURE:
      return {
        ...state,
        isSavingChartInProgress: false,
      };
    case REMOVING_CHART:
      return {
        ...state,
        isDeletingChartInProgress: true,
      };
    case REMOVING_CHART_SUCCESS:
    case REMOVING_CHART_FAILURE:
      return {
        ...state,
        isDeletingChartInProgress: false,
      };
    case FETCH_INITIAL_DATA_FOR_CHART_ACCOUNT_MODAL:
      return {
        ...state,
        isFetchingInitialDataForAddAndEditChartAccountModal: true,
      };
    case FETCH_INITIAL_DATA_FOR_CHART_ACCOUNT_MODAL_FAILURE:
      return {
        ...state,
        isFetchingInitialDataForAddAndEditChartAccountModal: false,
      };
    case FETCH_INITIAL_DATA_FOR_CHART_ACCOUNT_MODAL_SUCCESS:
      return {
        ...state,
        r2rAccountValues: action.r2rAccountValues,
        importStatusValues: action.importStatusValues,
        isFetchingInitialDataForAddAndEditChartAccountModal: false,
      };
    case SAVING_CHART_ACCOUNT:
      return {
        ...state,
        isSavingInProgress: true,
      };
    case SAVING_CHART_ACCOUNT_SUCCESS:
    case SAVING_CHART_ACCOUNT_FAILURE:
      return {
        ...state,
        isSavingInProgress: false,
      };
    case REMOVING_CHART_ACCOUNT:
      return {
        ...state,
        isRemovingChartAccountInProgress: true,
      };
    case REMOVING_CHART_ACCOUNT_SUCCESS:
    case REMOVING_CHART_ACCOUNT_FAILURE:
      return {
        ...state,
        isRemovingChartAccountInProgress: false,
      };
    case IMPORT_CHART_OF_ACCOUNTS:
      return {
        ...state,
        chartAccountsImporting: true,
      };
    case IMPORT_CHART_OF_ACCOUNTS_SUCCESS:
      return {
        ...state,
        chartAccountsImporting: false,
      };
    case IMPORT_CHART_OF_ACCOUNTS_FAILURE:
      return {
        ...state,
        chartAccountsImporting: false,
      };
    default:
      return state;
  }
}

export default chartOfAccounts;
